<template>
	<v-container fluid>
		<v-layout text-xs-center wrap>
			<v-flex xs12 sm6 lg4 px-4>
				<v-card>
					<v-card-title>
						<span class="headline">Registo de dados</span>
					</v-card-title>

					<v-card-text>
						<v-container grid-list-md>
							<p class="subtitle-2">Consulta e edição de dados das escolas, turmas e alunos envolvidas/os no projecto.</p>
						</v-container>
					</v-card-text>

					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="primary" text @click="$router.push('lista-escolas')">Lista de Escolas</v-btn>
					</v-card-actions>
				</v-card>
			</v-flex>
			
			<v-flex xs12 sm6 lg4 px-4 v-if="isAdmin">
				<v-card>
					<v-card-title>
						<span class="headline">Pesquisa de Alunos</span>
					</v-card-title>

					<v-card-text>
						<v-container grid-list-md>
							<p class="subtitle-2">Pesquisa rápida de alunos alvo de intervenção.</p>
						</v-container>
					</v-card-text>

					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="primary" text @click="$router.push('pesquisa-alunos')">Pesquisa</v-btn>
					</v-card-actions>
				</v-card>
			</v-flex>
			
			<v-flex xs12 sm6 lg4 px-4 v-if="isAdmin">
				<v-card>
					<v-card-title>
						<span class="headline">Estatísticas</span>
					</v-card-title>

					<v-card-text>
						<v-container grid-list-md>
							<p class="subtitle-2">Consulta de dados estatísticos do projecto.</p>
						</v-container>
					</v-card-text>

					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="primary" text @click="$router.push('estatisticas')">Estatísticas</v-btn>
						<v-btn color="primary" text href="static/resultados_finais.html" target="_blank">Resultados finais</v-btn>
					</v-card-actions>
				</v-card>
			</v-flex>
		</v-layout>

		<v-snackbar v-model="Message.show" :color="Message.type" top absolute multi-line :timeout="5000">
			{{ Message.text }}
			<v-btn text @click="Message.show = false">Fechar</v-btn>
		</v-snackbar>
	</v-container>
</template>

<script>
	import UserService from '@/services/user.service';
	const userService = new UserService();

    export default {
		data: () => ({
			Message: {
				show: false,
				type: null,
				text: null
			},
			Observacoes: {
				observacoes: null
			}
		}),

        computed: {
			isAdmin () {
				return userService.isAdmin();
			}
		},

        methods: {
			disponivelBrevemente () {
				this.Message.type = 'info';
				this.Message.text = 'Funcionalidade disponível brevemente.';
				this.Message.show = true;
			}
        }
    }
</script>